export default __webpack_public_path__ + "static/column-span-light-40e4ce8f04693e4f5c8fb57037e0e1d439d84439a931e8a606b3347502cadad0.png";